import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { lockerService } from '../_services';

import { Table, Collapse } from "react-bootstrap";

function getAreas(list) {
    const seen = {};
    const uniqueList = [];
    var areaTotals = {};
    var areaToggles = {};

    if (!list) {
        return [];
    }
    for (const item of list) {
        if (!seen[item.area]) {
            seen[item.area] = true;
            var area = { area: item.area, total: item.total, disabled: item.disabled, rented: item.rented }
            uniqueList.push(item.area);
            areaTotals[item.area] = area;
            areaToggles[item.area] = false;
        } else {
            areaTotals[item.area].total += item.total;
            areaTotals[item.area].disabled += item.disabled;
            areaTotals[item.area].rented += item.rented;
        }
    }

    return [uniqueList, areaTotals, areaToggles];
}


function List({ match }) {
    const { path } = match;
    const [lockers, setLockers] = useState(null);
    const [areas, setAreas] = useState([]);
    const [areaTotals, setAreaTotals] = useState(null);
    const [areaToggles, setAreaToggles] = useState(null);

    useEffect(() => {
        lockerService.getUtilization()
            .then(x => {
                setLockers(x);
                let areaInfo = getAreas(x);
                setAreaTotals(areaInfo[1]);
                setAreaToggles(areaInfo[2]);
                setAreas(areaInfo[0]);
            })
    }, []);

    const handleClick = (area) => {

        setAreaToggles(prevAreaToggles => {
            const newAreaToggles = { ...prevAreaToggles };
            newAreaToggles[area] = !prevAreaToggles[area];
            return newAreaToggles;
        });
    };

    const rows = (!areas) ? "" : areas.map((area) =>
        <React.Fragment>
            <tr>
                <td><a href="#" className="link link-primary" onClick={(event) => { event.preventDefault(); handleClick(area) }} >
                    {areaToggles[area] && <span className="glyphicon glyphicon-plus">  -  </span>}
                    {!areaToggles[area] && <span className="glyphicon glyphicon-minus">  +  </span>} 
                    {area}

                </a></td>
                <td>{areaTotals[area].total}</td>
                <td>{areaTotals[area].disabled}</td>
                <td>{areaTotals[area].rented}</td>
                <td>{(areaTotals[area].total == 0 ? 0 : (( areaTotals[area].rented + areaTotals[area].disabled ) / areaTotals[area].total ) * 100).toFixed(0).toLocaleString(0)}%</td>
            </tr>
            <tr>
                <td colSpan={5} style={{ padding: 0 }}>
                    <Collapse in={areaToggles[area]}>
                        <div>
                            <Table striped responsive="lg">
                                <thead>
                                    <tr>
                                        <th style={{ width: '10%', background: 'white' }} >Kiosk</th>
                                        <th style={{ width: '10%', background: 'white' }} >Size</th>
                                        <th style={{ background: 'white' }}>Total</th>
                                        <th style={{ background: 'white' }} >Disabled</th>
                                        <th style={{ background: 'white' }}>Rented</th>
                                        <th style={{ background: 'white' }}>Utilization</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lockers.filter((locker) => locker.area === area).map((locker) => (
                                        <tr key={locker.kiosk + locker.name}>
                                            <td style={{ background: 'white' }} className="text-nowrap" >
                                            <Link to={`${path}/kiosks/${locker.kiosk}`} className="">{locker.kiosk}</Link>
                                            </td>
                                            <td style={{ background: 'white' }} >{locker.name}</td>
                                            <td style={{ background: 'white' }} >{locker.total}</td>
                                            <td style={{ background: 'white' }} >{locker.disabled}</td>
                                            <td style={{ background: 'white' }} >{locker.rented}</td>
                                            <td style={{ background: 'white' }} >{(locker.total  == 0 ? 0 : ((locker.rented + locker.disabled) / locker.total ) * 100).toFixed(0).toLocaleString(0)}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Collapse>
                </td>
            </tr>

        </React.Fragment>
    );

    return (

       
            <div className="card m-3">
                <h1 className="card-header">Live Locker Utilization</h1>

            <Table striped responsive="lg">
                <thead>
                    <tr>
                        <th style={{ width:'20%' }}>Area</th>
                        <th>Total</th>
                        <th>Disabled</th>
                        <th>Rented</th>
                        <th>Utilization</th>
                    </tr>
                </thead>
                <tbody>

                    {rows}

                </tbody>
            </Table>

        </div>
    );
}

export { List };